import { render, staticRenderFns } from "./MyOrganization.vue?vue&type=template&id=14b8c392&scoped=true&"
import script from "./MyOrganization.vue?vue&type=script&lang=js&"
export * from "./MyOrganization.vue?vue&type=script&lang=js&"
import style0 from "./MyOrganization.vue?vue&type=style&index=0&id=14b8c392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8c392",
  null
  
)

export default component.exports